<template>
  <div v-show="isLoaded" class="mOthersHoney-container" v-observe-visibility="startAnimate">
    <div class="mOthersHoney-title">
      <h2 class="Others-title" :class="{animate: animate}">Conoce <br> <span class="title-span">Otros <span class="subtitle-span">Sabores</span></span></h2>
    </div>
    <div class="mOthersHoney-sku">
      <div class="mRow">
        <router-link
          :to="{name: 'goldApple'}"
          :class="{animate: animate}"
        >
          <img class="bottle-mobile gold" :src="gold" alt="Gold Apple"  />
          <img class="bottle-desktop" :src="desktopgold" alt="Gold Apple" />      
        </router-link>
        <router-link
          :to="{name: 'redBerries'}"
          :class="{animate: animate}"
        >
          <img class="bottle-mobile" :src="redberries" alt="Red Berries" />
          <img class="bottle-desktop" :src="desktopred" alt="Red Berries" />  
        </router-link>
        <router-link
          :to="{name: 'roseApple'}"
          :class="{animate: animate}"
        >
          <img class="bottle-mobile" :src="rose" alt="Rosé Apple" />
          <img class="bottle-desktop" :src="desktoprose" alt="Rosé Apple" />  
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import redberries from "@/assets/RED_BERRIES.png";
import gold from "@/assets/GOLD.png";
import rose from "@/assets/ROSE.png";
import desktopred from "@/assets/desktop_redberries.png"
import desktoprose from "@/assets/desktop_roseapple.png"
import desktopgold from "@/assets/desktop_goldapple.png"
import { mapGetters } from "vuex";
import Bowser from "bowser";

export default {
  name: "OthersHoney",
  data() {
    return {
      redberries,
      gold,
      rose,
      desktopred,
      desktoprose,
      desktopgold,
      animate: false,
      isSafari: false,
    };
  },
  computed: {
    ...mapGetters(["isLoaded"]),
  },
  methods: {
    startAnimate(isVisible) {
      if(isVisible) {
        this.animate=true
      }
    }
  },
  components: {},
  beforeMount() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    if (browser.getBrowserName()=='Safari') {
      this.isSafari = true
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/Honey/OthersHoney.scss";
</style>
